export const API_KEY = process.env.VF_FIREBASE_API_KEY || ''
export const PROJECT_ID = process.env.VF_FIREBASE_PROJECT_ID || ''
export const MESSAGING_SENDER_ID = process.env.VF_FIREBASE_MESSAGING_SENDER_ID || ''
export const APP_ID = process.env.VF_FIREBASE_APP_ID || ''
export const MEASUREMENT_ID = process.env.VF_FIREBASE_MEASUREMENT_ID || undefined
export const VAPID_KEY = process.env.VF_FIREBASE_VAPID_KEY || ''

export const FirebaseConfig = {
  apiKey: API_KEY,
  authDomain: `${PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${PROJECT_ID}-default-rtdb.firebaseio.com`,
  projectId: PROJECT_ID,
  storageBucket: `${PROJECT_ID}.appspot.com`,
  messagingSenderId: MESSAGING_SENDER_ID,
  appId: APP_ID,
  measurementId: MEASUREMENT_ID,
}

export enum MediumsEnum {
  WHATSAPP = 'WHATSAPP',
  TELEGRAM = 'TELEGRAM',
  SMS = 'SMS',
}
